'use client';

import {
    Drawer,
    Heading,
    TextPassage,
    Band,
    Icon,
    SkeletonBar,
} from '@petsmart-ui/sparky';
import sanitizeHtml from 'sanitize-html';
import { Divider } from '@libs/common-next';
import { decodeEntityString } from '@libs/algolia';
import type { OfferDetailsProps } from './types';

import './OfferDrawer.scss';

export default function OfferDetails({
    promotionName,
    discountDetails,
    onClose,
    isOpen = false,
    isLoading = false,
}: Readonly<OfferDetailsProps>) {
    return (
        <Drawer align="right" onClose={onClose} isActive={isOpen}>
            <Drawer.Header>
                <Heading size="headline" tagName="h2">
                    Offer Details
                </Heading>
            </Drawer.Header>
            <Drawer.Body>
                <div className="promo-msg-wrapper">
                    <Band className="promo-msg-icon">
                        <Icon name="tag" size="lg" />
                    </Band>

                    <Heading size="body-lg-bold" tagName="h3">
                        {promotionName}
                    </Heading>
                </div>
                <Divider />
                <TextPassage className="product-promotion-details-text">
                    <Heading size="body-lg-bold" tagName="h3">
                        Terms and Conditions
                    </Heading>
                    {isLoading ? (
                        <div className="product-promotion-details-text-skeleton">
                            <SkeletonBar size="sm" />
                            <SkeletonBar size="sm" />
                            <SkeletonBar size="sm" />
                        </div>
                    ) : (
                        decodeEntityString(
                            sanitizeHtml(
                                discountDetails?.termsAndConditions ?? ''
                            )
                        )
                    )}
                </TextPassage>
            </Drawer.Body>
        </Drawer>
    );
}
